/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserWalletInfoRespVo } from './UserWalletInfoRespVo';
import {
    UserWalletInfoRespVoFromJSON,
    UserWalletInfoRespVoFromJSONTyped,
    UserWalletInfoRespVoToJSON,
    UserWalletInfoRespVoToJSONTyped,
} from './UserWalletInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListUserWalletInfoRespVo
 */
export interface ResponseListUserWalletInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListUserWalletInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListUserWalletInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<UserWalletInfoRespVo>}
     * @memberof ResponseListUserWalletInfoRespVo
     */
    data?: Array<UserWalletInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListUserWalletInfoRespVo interface.
 */
export function instanceOfResponseListUserWalletInfoRespVo(value: object): value is ResponseListUserWalletInfoRespVo {
    return true;
}

export function ResponseListUserWalletInfoRespVoFromJSON(json: any): ResponseListUserWalletInfoRespVo {
    return ResponseListUserWalletInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListUserWalletInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListUserWalletInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserWalletInfoRespVoFromJSON)),
    };
}

export function ResponseListUserWalletInfoRespVoToJSON(json: any): ResponseListUserWalletInfoRespVo {
    return ResponseListUserWalletInfoRespVoToJSONTyped(json, false);
}

export function ResponseListUserWalletInfoRespVoToJSONTyped(value?: ResponseListUserWalletInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserWalletInfoRespVoToJSON)),
    };
}

